import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, Youtube, Twitter } from "lucide-react";
import { useSite, telLink, waLink } from "@/context/SiteContext";

const cols = [
  { title: "Company", links: [["About Us", "/about"], ["Contact", "/contact"], ["Fleet", "/fleet"], ["Tour Packages", "/tour-packages"], ["Blog", "/blog"]] },
  { title: "Taxi Services", links: [["Local Taxi", "/taxi-services/local-taxi"], ["Airport Taxi", "/taxi-services/airport-taxi"], ["Outstation Taxi", "/taxi-services/outstation-taxi"], ["One Way Taxi", "/taxi-services/one-way-taxi"], ["Round Trip Taxi", "/taxi-services/round-trip-taxi"]] },
  { title: "Locations", links: [["Jodhpur", "/jodhpur-taxi"], ["Jaipur", "/jaipur-taxi"], ["Udaipur", "/udaipur-taxi"], ["Jaisalmer", "/jaisalmer-taxi"]] },
  { title: "Popular Routes", links: [["Jodhpur to Jaipur", "/routes/jodhpur-to-jaipur"], ["Jodhpur to Jaisalmer", "/routes/jodhpur-to-jaisalmer"], ["Jodhpur to Udaipur", "/routes/jodhpur-to-udaipur"]] },
  { title: "Legal", links: [["Privacy Policy", "/privacy-policy"], ["Terms & Conditions", "/terms-conditions"], ["Sitemap", "/sitemap"]] },
];

export default function Footer() {
  const s = useSite();
  const socials = [
    [s.facebook, Facebook], [s.instagram, Instagram], [s.youtube, Youtube], [s.twitter, Twitter],
  ].filter(([u]) => u);

  return (
    <footer className="bg-navy text-slate-300" data-testid="site-footer">
      <div className="bg-royal">
        <div className="container-x py-8 flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
          <h2 className="text-2xl sm:text-3xl font-heading font-bold text-white">Book Your Taxi Today</h2>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <Link to="/book-taxi" className="bg-white text-royal font-semibold px-6 py-3 rounded-full hover:bg-brand-light transition-colors" data-testid="footer-book-btn">Book a Taxi</Link>
            <a href={telLink(s)} className="border border-white/60 text-white font-semibold px-6 py-3 rounded-full hover:bg-white/10 transition-colors">Call {s.phone}</a>
          </div>
        </div>
      </div>

      <div className="container-x py-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
        <div className="col-span-2 md:col-span-3 lg:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <img src={s.logo} alt="Chouhan Taxi Service logo" className="h-12 w-12 rounded-full object-cover" />
            <span className="font-heading font-bold text-white text-lg">Chouhan Taxi Service</span>
          </div>
          <p className="text-sm leading-relaxed mb-4">Reliable taxi, cab and tour & travel service across Jodhpur, Jaipur, Udaipur and Jaisalmer.</p>
          <div className="space-y-2 text-sm">
            <a href={telLink(s)} className="flex items-center gap-2 hover:text-brand-sky"><Phone className="w-4 h-4 text-brand-sky" /> {s.phone}</a>
            <a href={`mailto:${s.email}`} className="flex items-center gap-2 hover:text-brand-sky"><Mail className="w-4 h-4 text-brand-sky" /> {s.email}</a>
            <p className="flex items-start gap-2"><MapPin className="w-4 h-4 text-brand-sky mt-0.5 shrink-0" /> {s.address}</p>
          </div>
          {socials.length > 0 && (
            <div className="flex gap-3 mt-4">
              {socials.map(([url, Icon], i) => (
                <a key={i} href={url} target="_blank" rel="noreferrer" className="bg-white/10 p-2 rounded-full hover:bg-brand transition-colors"><Icon className="w-4 h-4 text-white" /></a>
              ))}
            </div>
          )}
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <h3 className="text-white font-heading font-semibold mb-4 text-sm uppercase tracking-wider">{c.title}</h3>
            <ul className="space-y-2.5 text-sm">
              {c.links.map(([label, to]) => (
                <li key={to}><Link to={to} className="hover:text-brand-sky transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-5 text-center text-xs text-slate-400">
          © {new Date().getFullYear()} Chouhan Taxi Service · Tour & Travel · Mehrangarh Fort Road, Jodhpur, Rajasthan 342024
        </div>
      </div>
    </footer>
  );
}
